// extracted by mini-css-extract-plugin
export default {"helpText":"xtC6wyNGRbBFlHJL0Gcr"};